/**
 * Словарь иконок vuesax для BaseIconPicker (`vuesax:имя-файла`).
 * Файлы лежат в app/assets/icons/vuesax (см. nuxt icon.customCollections).
 * Обновить список: `npm run gen:vuesax-icons` (также выполняется перед `npm run dev`)
 */
export const VUESAX_ICONS_DICTIONARY = [
  'vuesax:3dcube-twotone',
  'vuesax:activity-linear',
  'vuesax:add-bold',
  'vuesax:add-circle-bold',
  'vuesax:add-circle-linear',
  'vuesax:add-linear',
  'vuesax:add-square-bulk',
  'vuesax:add-square-linear',
  'vuesax:add-square-twotone',
  'vuesax:add-survey',
  'vuesax:archive-linear',
  'vuesax:arrow-down',
  'vuesax:arrow-left',
  'vuesax:arrow-left-chevron',
  'vuesax:arrow-redo-left-linear',
  'vuesax:arrow-redo-linear',
  'vuesax:arrow-right',
  'vuesax:arrow-right-chevron',
  'vuesax:arrow-right-linear',
  'vuesax:arrow-square-bold',
  'vuesax:arrow-square-down-bold',
  'vuesax:arrow-swap',
  'vuesax:arrow-up',
  'vuesax:back-square-linear',
  'vuesax:backward-10-seconds-linear',
  'vuesax:bank',
  'vuesax:book-twotone',
  'vuesax:box-empty-linear',
  'vuesax:box-linear',
  'vuesax:brush-2-twotone',
  'vuesax:buy-crypto-linear',
  'vuesax:calendar',
  'vuesax:calendar-8-linear',
  'vuesax:calendar-linear',
  'vuesax:call-calling',
  'vuesax:call-linear',
  'vuesax:candle-linear',
  'vuesax:category-2-linear',
  'vuesax:category-2-twotone',
  'vuesax:clock-linear',
  'vuesax:close',
  'vuesax:close-circle-bold',
  'vuesax:close-circle-linear',
  'vuesax:close-circle-twotone',
  'vuesax:close-linear',
  'vuesax:close-square-twotone',
  'vuesax:copy',
  'vuesax:copy-linear',
  'vuesax:crop-linear',
  'vuesax:danger-linear',
  'vuesax:direct-inbox-twotone',
  'vuesax:directbox-send-linear',
  'vuesax:document-copy-linear',
  'vuesax:document-download-linear',
  'vuesax:document-favorite-linear',
  'vuesax:document-text-linear',
  'vuesax:document-text-twotone',
  'vuesax:drag-dots-bold',
  'vuesax:edit',
  'vuesax:edit-2-linear',
  'vuesax:edit-linear',
  'vuesax:element-4-twotone',
  'vuesax:emoji-normal-twotone',
  'vuesax:export-2-linear',
  'vuesax:export-linear',
  'vuesax:eye',
  'vuesax:eye-slash',
  'vuesax:firstline',
  'vuesax:folder-add',
  'vuesax:forward-10-seconds-linear',
  'vuesax:gallery-add-linear',
  'vuesax:gallery-export',
  'vuesax:gallery-twotone',
  'vuesax:global-bulk',
  'vuesax:global-search-bulk',
  'vuesax:global-search-twotone',
  'vuesax:global-twotone',
  'vuesax:grid-6-linear',
  'vuesax:h1-linear',
  'vuesax:heart',
  'vuesax:heart-bold',
  'vuesax:heart-linear',
  'vuesax:home-1-linear',
  'vuesax:home-1-twotone',
  'vuesax:import-linear',
  'vuesax:info-circle-linear',
  'vuesax:list-linear',
  'vuesax:location-linear',
  'vuesax:lock',
  'vuesax:login-linear',
  'vuesax:logout',
  'vuesax:menu-linear',
  'vuesax:message-edit',
  'vuesax:message-edit-linear',
  'vuesax:message-question-twotone',
  'vuesax:message-text',
  'vuesax:message-text-bulk',
  'vuesax:message-text-linear',
  'vuesax:message-time-bulk',
  'vuesax:messages',
  'vuesax:messages-2',
  'vuesax:messages-2-linear',
  'vuesax:microphone-2-twotone',
  'vuesax:minus-square-twotone',
  'vuesax:mobile',
  'vuesax:money-4-twotone',
  'vuesax:monitor-bulk',
  'vuesax:moon-bold',
  'vuesax:moon-linear',
  'vuesax:more',
  'vuesax:mouse-square-twotone',
  'vuesax:musicnote-twotone',
  'vuesax:note',
  'vuesax:note-linear',
  'vuesax:notification',
  'vuesax:numbering-linear',
  'vuesax:open-full-linear',
  'vuesax:pause-bold',
  'vuesax:pause-circle-bold',
  'vuesax:pause-circle-linear',
  'vuesax:people-twotone',
  'vuesax:personalcard-twotone',
  'vuesax:play-bold',
  'vuesax:play-circle-bold',
  'vuesax:play-circle-linear',
  'vuesax:play-mdi-bold',
  'vuesax:play-speed-bold',
  'vuesax:price-circle-linear',
  'vuesax:price-circle-solid',
  'vuesax:printer-linear',
  'vuesax:profile-2user',
  'vuesax:profile-circle-linear',
  'vuesax:profile-tick-bulk',
  'vuesax:profile-tick-twotone',
  'vuesax:refresh-2-linear',
  'vuesax:refresh-2-twotone',
  'vuesax:repeat-music-linear',
  'vuesax:scan-barcode',
  'vuesax:search-normal',
  'vuesax:search-zoom-in-linear',
  'vuesax:send-linear',
  'vuesax:send-square-2-linear',
  'vuesax:setting-2-linear',
  'vuesax:setting-3',
  'vuesax:share-05-linear',
  'vuesax:share-05-twotone',
  'vuesax:slider-horizontal-bold',
  'vuesax:slider-horizontal-linear',
  'vuesax:slider-horizontal-twotone',
  'vuesax:slider-vertical',
  'vuesax:smallcaps',
  'vuesax:smallcaps-bold',
  'vuesax:smallcaps-linear',
  'vuesax:sms',
  'vuesax:sms-linear',
  'vuesax:sms-tracking-linear',
  'vuesax:star-bold',
  'vuesax:star-bulk',
  'vuesax:star-linear',
  'vuesax:sun-fog-linear',
  'vuesax:sun-linear',
  'vuesax:tag-cross-linear',
  'vuesax:task-linear',
  'vuesax:task-square-linear',
  'vuesax:text-bold-linear',
  'vuesax:text-italic-linear',
  'vuesax:text-linear',
  'vuesax:text-strikethrough-bold',
  'vuesax:text-underline-linear',
  'vuesax:textalign-center-linear',
  'vuesax:textalign-justifycenter-linear',
  'vuesax:textalign-left-linear',
  'vuesax:textalign-left-twotone',
  'vuesax:textalign-right-linear',
  'vuesax:tick-circle',
  'vuesax:tick-circle-bold',
  'vuesax:tick-circle-linear',
  'vuesax:tick-square-bold',
  'vuesax:tick-square-bulk',
  'vuesax:tick-square-linear',
  'vuesax:tick-square-twotone',
  'vuesax:toggle-image-linear',
  'vuesax:trash-linear',
  'vuesax:tree-twotone',
  'vuesax:user-add',
  'vuesax:user-circle-add-bold',
  'vuesax:user-square-linear',
  'vuesax:video-add-linear',
  'vuesax:video-add-outline',
  'vuesax:video-square-linear',
  'vuesax:video-square-twotone',
  'vuesax:weight-linear',
] as const

export type VuesaxIconId = (typeof VUESAX_ICONS_DICTIONARY)[number]
